import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import "../PrivacyPolicy.css";

function Privacy() {
  return (
    <div>
      <Container fluid id="hero" className="herosection">
        <Container fluid className="containersectionabt">
          <Row>
            <Col xs={12} md={8} lg={6}>
              <h2
                style={{
                  color: "#FFFFFF",
                  fontFamily: "jost",
                  fontSize: 2.5 + "rem",
                }}
              >
                <strong>Our Privacy & Cookie Policy</strong>
              </h2>
              <p
                style={{
                  color: "#FFFFFF",
                  fontSize: 0.75 + "rem",
                  lineHeight: 224 + "%",
                  fontFamily: "jost",
                }}
              >
                Please carefully review our privacy and cookie policies provided
                below.{" "}
              </p>
            </Col>
            <Col xs={12} md={4} lg={6}></Col>
          </Row>
        </Container>
      </Container>

      <Container
        fluid
        id="hero"
        className="headings"
        style={{ marginTop: -4 + "rem", fontFamily: "jost" }}
      >
        <Container>
          <h3>
            <strong>Section 1: Contractual Relationships:</strong>
          </h3>
          <p className="privacy-content">
            These Terms of Use (“Terms”) govern the access or use by you, an
            individual or entity, of the applications (including mobile
            applications), websites, content, products, and services
            (collectively, the “Services”) made available by Lodapoint
            Technologies Ltd and its subsidiaries and affiliates (collectively,
            “Lodapoint”)
          </p>
          <p className="privacy-content">
            In these Terms, the words “including” and “include” mean “including,
            but not limited to. Your access and use of the Services constitutes
            your agreement to be bound by these Terms, which establishes a
            contractual relationship between you and Lodapoint.
          </p>

          <p className="privacy-content">
            These Terms supersede any other agreements with respect to the
            subject matter of these Terms, except that with respect to any
            sender or motor carrier agreement between the sender or carrier
            you represent (as applicable) and Lodapoint, such agreement shall
            not be superseded by these Terms, and to the extent that such other
            agreement is inconsistent with these Terms, such other agreement
            will govern. Lodapoint may, at any time for any reason, without
            notice to you, cease offering you access to the Services or any
            portion thereof or deny you access to the Services or any portion
            thereof. You agree to maintain all your login credentials to access
            or use the Services in confidence and only permit your authorized
            users to access or use the Services. You are responsible for all
            activity that occurs under your login credentials.
          </p>

          <p className="privacy-content">
            Lodapoint may amend these Terms from time to time. Amendments will
            be effective upon Lodapoint’s posting of such updated Terms at this
            location. Your continued access or use of the Services after such
            posting constitutes your consent to be bound by the Terms, as
            amended. Please refer to Lodapoint Privacy Notice located here for
            information about our collection and use of personal information in
            connection with the Services.
          </p>

          <h3 style={{ marginTop: 2.5 + "rem" }}>
            <strong>
              Section 2: License Subject to your compliance with these Terms.
            </strong>
          </h3>
          <p className="privacy-content">
            Lodapoint grants you a limited, non-exclusive, non-sub licensable,
            revocable, non-transferable license to access and use the Services.
            Any rights not expressly granted herein are reserved by Lodapoint
            (and its affiliates, as applicable) and Lodapoint’s licensors.
          </p>
          <p className="privacy-content">
            <b>Restrictions:</b> You may not, and may not authorize others to:
            (i) remove any copyright, trademark or other proprietary notices
            from any portion of the Services; (ii) reproduce, modify, prepare
            derivative works based upon, distribute, license, lease, sell,
            resell, transfer, publicly display, publicly perform, transmit,
            stream, broadcast or otherwise exploit the Services except as
            expressly permitted by Lodapoint; (iii) decompile, disassemble,
            reverse engineer or otherwise attempt to derive the source code or
            underlying technology, methodologies or algorithms of the Services,
            except as may be permitted by applicable law; (iv) link to, mirror
            or frame any portion of the Services; (v) cause or launch any
            programs or scripts for the purpose of scraping, indexing,
            surveying, or otherwise data mining any portion of the Services, or
            unduly burdening or hindering the operation and/or functionality of
            any aspect of the Services; or (vi) attempt to gain unauthorized
            access to or impair any aspect of the Services or their related
            systems or networks.
          </p>

          <p className="privacy-content">
            <b>Ownership:</b> The Services and all rights therein are and shall
            remain Lodapoint’s property or the property of Lodapoint’s
            licensors. Neither these Terms nor your use of the Services convey
            or grant to you any rights: (i) in or related to the Services except
            for the limited license granted above; or (ii) to use or reference
            in any manner Lodapoint’s company names, logos, product and service
            names, trademarks or services marks or those of Lodapoint’s
            licensors. Section 3 Disclaimers; Limitation of Liability;
            Indemnity.
          </p>

          <p className="privacy-content">
            <b>Disclaimer:</b> The Services are provided “As Is” And “As
            Available.” Lodapoint disclaims all representations and warranties,
            express, implied, or statutory, Not expressly set out in these
            terms, including the implied warranties of merchantability, fitness
            for a particular purpose and non-infringement. In addition,
            Lodapoint makes no representation, warranty, or quarantee regarding
            the reliability, timeliness, quality, suitability, or availability
            of the services, or that where services will be uninterrupted or
            Error-Free. You agree that the entire risk arising out of your
            access or use of the services remains solely with you, to the
            maximum extent permitted under applicable Law.
          </p>

          <p className="privacy-content">
            <b>Limitation of Liability:</b> Lodapoint shall not be liable for
            indirect, incidental, special, exemplary, punitive, or consequential
            damages, including but not limited to lost profits, lost data,
            personal injury, or property damage related to, in connection with,
            or otherwise resulting from any use of the services, even if
            Lodapoint has been advised of the possibility of such damages.
            Lodapoint shall not be liable for any damages, liability or losses
            arising out of: (i) Your use of or reliance on the services or your
            inability to access or use the Services; or (ii) Any transaction or
            relationship between you and any third party provider, Even if
            Lodapoint has been advised of the possibility of such damages.
            Lodapoint shall not be liable for delay or failure in performance
            resulting from causes beyond Lodapoint’s reasonable control. In no
            event shall Lodapoint’s total liability to you in connection with
            the Services for all damages, Losses and causes of action exceed Ten
            Thousand Naira only (N10, 000.00). Lodapoint does not control,
            endorse or take responsibility for any user content or third-party
            content available on or linked to by the services (including
            information on the services provided by users or by senders).
            Lodapoint cannot and does not represent or warrant that the services
            or servers are free of viruses or other harmful components.
          </p>

          <p className="privacy-content">
            <b>Indemnity:</b> You agree to indemnify and hold Lodapoint and its
            affiliates and its and their respective officers, directors,
            employees, and agents harmless from any and all claims, demands,
            losses, liabilities, and expenses (including attorneys’ fees),
            arising out of or in connection with: (i) your use of the Services;
            and/or (ii) your breach or violation of any of these Terms.
          </p>

          <h3 style={{ marginTop: 2.5 + "rem" }}>
            <strong>Section 3: Dispute Resolution Arbitration:</strong>
          </h3>
          <p className="privacy-content">
            Wherein a dispute arises between the parties, the parties shall
            attempt to resolve dispute amicably by mutual consultation and when
            no attempt at mutual consultation is initiated and attempted by any
            of the parties within 30 days of the occurrence of the event or
            dispute either party may seek legal remedies and redress if any. The
            Parties agree that this Agreement shall be interpreted and construed
            in accordance with the Laws of [Nigeria] and that should any claim
            be brought related to terms or conditions as stated in this
            agreement, it shall be brought within a court of competent
            jurisdiction within Nigeria.
          </p>

          <p className="privacy-content">
            <b>Text Messaging and Telephone Calls:</b> You agree that Lodapoint
            may contact you by telephone or SMS messages (including by an
            automatic telephone dialing system and/or with an artificial or
            pre-recorded voice) at any of the phone numbers provided by you or
            on your behalf, including for marketing purposes. You understand
            that you are not required to provide this consent as a condition of
            purchasing any property, goods or services. You also understand that
            you may opt out of receiving SMS messages from Lodapoint at any
            time, either by replying with the word “STOP” using the mobile
            device that is receiving the messages.
          </p>

          <p className="privacy-content">
            <b>User Provided Content:</b> Lodapoint may, in its sole discretion,
            permit you from time to time to submit, upload, publish or otherwise
            make available to Lodapoint through the Services textual, audio,
            visual or other content and information, including load information,
            commentary and feedback related to the Services, ratings and reviews
            (including of motor carriers and facilities), initiation of support
            requests, and submission of entries for competitions and promotions
            (“User Content”). Any User Content provided by you remains your
            property. However, by providing User Content to Lodapoint, you grant
            it a worldwide, perpetual, irrevocable, transferable, royalty-free
            license, with the right to sublicense, to use, copy, modify, create
            derivative works of, distribute, publicly display, publicly perform,
            and otherwise exploit in any manner such User Content in all formats
            and distribution channels now known or hereafter devised (including
            in connection with the Services and Lodapoint’s business and on
            third-party sites and services), without further notice to or
            consent from you, and without the requirement of payment to you or
            any other person or entity. You represent and warrant that: (i) you
            either are the sole and exclusive owner of all User Content or you
            have all rights, licenses, consents and releases necessary to grant
            Lodapoint the license to the User Content as set forth above; and
            (ii) neither the User Content, nor your submission, uploading,
            publishing or otherwise making available of such User Content, nor
            Lodapoint’s use of the User Content as permitted herein will
            infringe, misappropriate or violate a third party’s intellectual
            property or proprietary rights, or rights of publicity or privacy,
            or result in the violation of any applicable law or regulation. You
            agree to not provide User Content that is defamatory, libelous,
            hateful, violent, obscene, pornographic, unlawful, or otherwise
            offensive, as determined by Lodapoint in its sole discretion,
            whether or not such material may be protected by law. Lodapoint may,
            but shall not be obligated to, review, monitor, or remove User
            Content, at its sole discretion and at any time and for any reason,
            without notice to you.
          </p>

          <p className="privacy-content">
            <b>Network Access and Devices:</b> You are responsible for obtaining
            the data network access necessary to use the Services. Your mobile
            network’s data and messaging rates and fees may apply if you access
            or use the Services from your device. You are responsible for
            acquiring and updating compatible hardware or devices necessary to
            access and use the Services and applications and any updates
            thereto. Lodapoint does not guarantee that the Services, or any
            portion thereof, will function on any particular hardware or
            devices. In addition, the Services may be subject to malfunctions
            and delays inherent in the use of the Internet and electronic
            communications.
          </p>

          <p className="privacy-content">
            <b>Notice:</b> Lodapoint may give notice by means of a general
            notice on the Services, electronic mail to your email address in
            your Account, or by written communication sent by first class mail
            or pre-paid post to your address in your Account. Such notice shall
            be deemed to have been given upon the expiration of 48 hours after
            mailing or posting (if sent by first class mail or pre-paid post) or
            12 hours after sending (if sent by email). You may give notice to
            Lodapoint, with such notice deemed given when received by Lodapoint,
            at any time by first class mail or pre-paid post to Lodapoint’s
            headquarters.
          </p>

          <p className="privacy-content">
            <b>General:</b> You may not assign these Terms without Lodapoint’s
            prior written approval. Lodapoint may assign these Terms without
            your consent to: (i) a subsidiary or affiliate; (ii) an acquirer of
            Lodapoint’s equity, business or assets; or (iii) a successor by
            merger. Any purported assignment in violation of this section shall
            be void. No joint venture, partnership, employment, or agency
            relationship exists between you, Lodapoint or any third party as a
            result of these Terms or use of the Services. If any provision of
            these Terms is held to be invalid or unenforceable, such provision
            shall be struck and the remaining provisions shall be enforced to
            the fullest extent under law. Lodapoint’s failure to enforce any
            right or provision in these Terms shall not constitute a waiver of
            such right or provision unless acknowledged and agreed to by
            Lodapoint in writing.
          </p>

          <p className="privacy-content">
            <b>Attorney’s Review:</b> Parties warrants and represents that in
            executing the Agreement has had the opportunity to rely on legal
            advice from an attorney of his choice, so that the terms of this
            Agreement and their consequences could have been fully read and
            explained to the land owner by an attorney and that he fully
            understands the terms of this Agreement.
          </p>

          <p className="privacy-content">
            <b>Choice of Language:</b> It is the express wish of the parties
            that these terms and conditions be drawn up in English. These terms
            may be translated into other languages. In the event of a difference
            in interpretation between the English version of these terms and
            another version, the English version shall
          </p>
        </Container>
      </Container>
    </div>
  );
}

export default Privacy;
